module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/store_images/3_969e14ad1bfd07d737292eefd8c69c59.png";